import styled from "styled-components";
import { theme } from "@sqymagma/theme";
import { ReactComponent as KamelloSvg } from "@images/kamello-home.svg";

export const CamelIcon = styled(KamelloSvg)`
  path {
    fill: ${theme("colors.text01")};
  }
`;
